import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    login: {
        token: string,
        user: {
            role: 'CLIENT' | 'STAFF' | 'ADMIN',
            name: string,
        }
    }
}

interface Variables {
    email: string,
    otp: string,
}

export const LOGIN: TypedDocumentNode<Result, Variables> = gql`
    query Login($otp: String!, $email: String!) {
        login(otp: $otp, email: $email) {
            token
            user {
                id
                role
            }
        }
    }       
`
